import WarningAlertIcon from 'assets/svg/app/alert-triangle.svg'
import AlertIcon from 'assets/svg/app/alert.svg'

import { useNetworkStatus } from 'hooks/useNetworkStatus'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { NETWORK_BRANDWIDTH_TRADEOFF } from 'state/constants'
import media from 'styles/media'
import { Body } from './Text'
import { FlexDiv } from './layout/flex'

export default function NetworkStatusBanner() {
	const { t } = useTranslation()

	const isOnline = useNetworkStatus()
	if (isOnline) {
		if (
			// @ts-ignore
			navigator.connection?.downlink &&
			// @ts-ignore
			navigator.connection.downlink < NETWORK_BRANDWIDTH_TRADEOFF
		) {
			return (
				<WarningBannerContainer>
					<IconContainer>
						<WarningAlertIcon />
					</IconContainer>
					<Body>{t('futures.market.errors.slow-connection')}</Body>
				</WarningBannerContainer>
			)
		}
		return null
	}

	return (
		<ErrorBannerContainer>
			<IconContainer>
				<AlertIcon />
			</IconContainer>
			<Body>{t('futures.market.errors.network-disconnected')}</Body>
		</ErrorBannerContainer>
	)
}

const BannerContainer = styled(FlexDiv)`
  column-gap: 8px;
  padding: 10px;
  position: fixed;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  border-radius: 8px;
  z-index: 1000;
  text-align: center;

  ${media.lessThan('md')`
    left: 0;
    transform: translateX(0);
    margin: 0 20px;
    bottom: 80px;
  `}
`

const ErrorBannerContainer = styled(BannerContainer)`
  background-color: ${(props) => props.theme.colors.selectedTheme.newTheme.banner.alert.error.background};
  color: ${(props) => props.theme.colors.selectedTheme.newTheme.banner.alert.error.text};
`

const WarningBannerContainer = styled(BannerContainer)`
  background-color: ${(props) => props.theme.colors.selectedTheme.newTheme.banner.alert.warnning.background};
  color: ${(props) => props.theme.colors.selectedTheme.newTheme.banner.alert.warnning.text};
`

const IconContainer = styled.div`
  width: 16px;
  height: 16px;
`
